import React from "react";
import { Facebook, Instagram, Youtube, MapPin, Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  const quickLinks = [
    "About Us",
    "Our Services",
    "Ministries",
    "Events",
    "Contact",
  ];

  const serviceTimes = [
    "Sunday English Service: 09:00 AM",
    "Sunday Malayalam Service: 10:00 AM",
    "Fasting Prayer: Fri 11:00 AM",
  ];

  const socialLinks = [
    { icon: Facebook, href: "https://www.facebook.com/churchofgodkoramangala" },
    { icon: Instagram, href: "https://www.instagram.com/cgikoramangala/?hl=en" },
    { icon: Youtube, href: "https://www.youtube.com/@cogkoramangala" },
  ];

  const newTab = { target: "_blank", rel: "noopener noreferrer" };

  return (
    <footer className="bg-slate-800 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Church Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4 w-52">
              <Link to="/home">
                <img src="/images/church-logo.png" alt="logo" />
              </Link>
            </div>
            <p className="text-slate-400 text-sm">
              Worshiping God in Spirit and Truth, building a community of faith,
              hope, and love in the heart of Bangalore.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h5 className="font-bold mb-4">Quick Links</h5>
            <ul className="space-y-2 text-sm">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href="#"
                    {...newTab}
                    className="text-slate-400 hover:text-white transition-colors"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Times */}
          <div>
            <h5 className="font-bold mb-4">Service Times</h5>
            <ul className="space-y-2 text-sm text-slate-400">
              {serviceTimes.map((time, index) => (
                <li key={index}>{time}</li>
              ))}
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h5 className="font-bold mb-4">Get In Touch</h5>
            <div className="space-y-3 text-sm text-slate-400 mb-4">
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-slate-500 flex-shrink-0" />
                <p>
                  # 418/8, 80 Feet Road, 6th Block, <br /> (Near BMTC Bus Depot) <br />
                  Koramangala, Bangalore, India, <br /> Pin 560 095.
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-slate-500 flex-shrink-0" />
                 <p>+91 94470 93119</p>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-slate-500 flex-shrink-0" />
                <p>info@cogkoramangala.org</p>
              </div>
            </div>
            <div className="flex space-x-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  {...newTab}
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-8 pt-8 text-center">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} Church of God, Koramangala. All rights
            reserved. | Designed and Developed by{" "}
            <a
              href="https://db-media.vercel.app/"
              {...newTab}
              className="text-cyan-400 underline hover:text-white transition-colors ml-1"
            >
              db media
            </a>
            {/* <a href="#" {...newTab} className="hover:text-white transition-colors ml-1">
              | Privacy Policy
            </a>{" "}
            |
            <a href="#" {...newTab} className="hover:text-white transition-colors ml-1">
              Terms of Service
            </a> */}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;